import VendorTeam from "work/values/vendor-team/vendor-team";

import { AccountType } from "common/values/account-type/account-type";
import Guid from "common/values/guid/guid";
import VendorTeamName from "work/values/vendor-team-name/vendor-team-name";
import VendorRepresentativeAPIRequest from "work/entities/entity-vendor-representative/api/request-contracts/vendor-representative-api-request";
import EntityMemberAPIRequest from "work/values/entity-member/api/request-contracts/entity-member-api-request";

export default class WorkTeamTemplateAPIRequest {
  entityId?: string;
  name?: string;
  leader?: VendorRepresentativeAPIRequest;
  members?: EntityMemberAPIRequest[];
  creatorType?: string;
  marketplaceId?: string;

  constructor(
    entityId: Guid,
    team: VendorTeam,
    name: VendorTeamName,
    creatorType: AccountType,
    marketplaceId?: Guid
  ) {
    this.entityId = entityId.value;
    this.name = name.value;
    this.leader = team.leader ? new VendorRepresentativeAPIRequest(team.leader) : undefined;
    this.members = team.members.map((member) => new EntityMemberAPIRequest(member.userId, member.entityId)); 
    this.creatorType = creatorType;
    this.marketplaceId = marketplaceId?.value;
  }
}
